import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const AUTO_COMPLETE_PRO_FACILITIES = gql`
  query ($input: AutoCompleteProFacilitiesInput!) {
    autoCompleteProFacilities(input: $input) {
      id
      name
      shipToAddress {
        city
        state
      }
      pro {
        id
        name
        email
      }
    }
  }
`

interface AutoCompleteProFacilitiesResponse {
  autoCompleteProFacilities: Facility[]
}

export const useAutoCompleteProFacilitiesApi = (
  term?: string,
): UseQueryResult<Facility[], Error> => {
  const client = useGraphQLClient()

  const fetchCart = async (): Promise<Facility[]> => {
    const data = await client.request<AutoCompleteProFacilitiesResponse>(
      AUTO_COMPLETE_PRO_FACILITIES,
      { input: { term } },
    )

    return data.autoCompleteProFacilities
  }

  return useQuery<Facility[], Error>({
    queryKey: ['autoCompleteProFacilities', term],
    queryFn: fetchCart,
    enabled: !!term,
  })
}
